// 用户行为 0访问 1复制 2点击 3曝光
export const DEED_MAP = {
  VISITED: 0,
  COPY: 1,
  CLICK: 2,
  EXPOSURE: 3,
};
// 事件编号
export const OID_MAP = {
  BOTTOM_BANNER_LOGIN_BTN_CLICK: 2079, //底部banner登录按钮
  DETAIL_TITLE_MODULE_BUTTON: 2067, // 详情页-标题模块按钮
  DETAIL_BANNER: 2068, // 详情页-广告横幅
  DETAIL_SUMMARY_VIEW_NOW: 2069, // 详情页-摘要-立即查看
  DETAIL_ANNEX_CLICK: 2070, // 详情页-附件
  DETAIL_OFFSIDE_LOGIN_BTN: 2071, // 详情页-右侧全网商机图
  DETAIL_ENTERPRISE_INFORMATION_POPUP: 2079, // 详情页-企业信息弹窗
  DETAIL_PROJECT_DETAIL_TITLE_MODULE_BUTTON: 2072, // 详情页-标题模块按钮
  DETAIL_PROJECT_DETAIL_FOLLOW_UP: 2073, // 拟在建详情-项目跟进-查看按钮
  DETAIL_PROJECT_DETAIL_CONTACT: 2074, // 拟在建详情-项目联系人-查看按钮
  DETAIL_APPROVAL_DETAIL_TITLE_MODULE_BUTTON: 2075, // 审批详情-项目联系人-查看按钮
  DETAIL_OWNER_ENTRUST_MODULE_BUTTON: 2095, // 业主委托项目详情页-标题模块按钮

  TENDER_INFORMATION_TYPE_NAV_MENU_CLICK: 2100, //信息类型落地页上方导航栏点击，记录页面与点击文案
  TENDER_INFORMATION_TYPE_LIST_CLICK: 2103, //信息类型落地页列表数据点击

  TENDER_INFORMATION_GOVERNMENT_ORGANS_CLICK: 2105, //信息类型落地页右侧-政府机构点击
  TENDER_INFORMATION_RECOMMEND_CLICK: 2106, //信息类型落地页右侧-招标推荐点击
  TENDER_INFORMATION_PURCHASING_AGENCY_CLICK: 2107, //信息类型落地页右侧-采购机构点击
  TENDER_INFORMATION_BIDDING_HOTS_CLICK: 2108, //信息类型落地页右侧-招标热点点击
  TENDER_INFORMATION_TENDER_ADVANCE: 2096, //招标预告落地页曝光
  TENDER_INFORMATION_TENDER_NOTICE: 2097, //招标公告落地页曝光
  TENDER_INFORMATION_TENDER_CHANGE: 2098, //招标变更落地页曝光
  TENDER_INFORMATION_TENDER_RESULT: 2099, //中标结果落地页曝光
  TENDER_INFORMATION_SEARCH_CLICK: 2102, //信息类型落地页-搜索点击
  TENDER_INFORMATION_AREA_CLICK: 2101, //信息类型落地页-地区点击
};
